import { render, staticRenderFns } from "./TenantInfoDisplay.vue?vue&type=template&id=54d23083&"
import script from "./TenantInfoDisplay.vue?vue&type=script&lang=ts&"
export * from "./TenantInfoDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports